$(document).ready(function() {
  $("[data-section-id='header']").addClass("transparent-header");
  $("#MainContent .shopify-section:first").addClass("transparent-header__section");
});
$(document).ready(function() {
  setTimeout(
  function checkWidth() { 
    var x = $(".docked-navigation-container").height() + 15;   // or any changing value
    $('.transparent-header__section').css({'margin-top' : '-' + x + 'px'});
  }, 500);
});

$(document).ready(function() {
    $(window).resize(function() {
      var x = $(".docked-navigation-container").height() + 15;   // or any changing value
      $('.transparent-header__section').css({'margin-top' : '-' + x + 'px'});
    }).resize();
});